import React from "react";
import PropTypes from "prop-types";

import { Wrapper } from "./MessageTray.styles";
import UINotificationSuccess from "components/UI/Notification/Success";
import UINotificationFailure from "components/UI/Notification/Failure";
import UINotificationWarning from "components/UI/Notification/Warning";

const MessageTray = ({ message }) => {
  const icon = {
    failure: (
      <i
        className="fas fa-exclamation-circle"
        style={{ color: "red", paddingRight: "4px" }}
      />
    ),
    success: (
      <i
        className="fas fa-check-circle"
        style={{ color: "green", paddingRight: "4px" }}
      />
    ),
    warning: (
      <i
        className="fas fa-exclamation-triangle"
        style={{ color: "#194fa1", paddingRight: "4px" }}
      />
    ),
    close: <i class="fas fa-times" style={{ float: "right" }} />
  };
  let notification;
  if (message) {

    let temp = message.text.split(/\r?\n/);
    temp = temp.filter(x => x !==  "");

    switch(message.type){

      case "info":
      case "success":
          notification = <UINotificationSuccess data-notif-success>
                          <div style={{ float: "left" }} id={`${message.type}_msg`} key="success_alert">
                            <ul>
                              {temp.map( (x, index) => <li id={`success_${index}`} key={`success_${index}`}>{icon.success}{x.replace("• ", "")}</li>)}
                            </ul>    
                          </div>
                        </UINotificationSuccess>;
      break; 

      case "error":
          notification =  <UINotificationFailure data-notif-failure>

                        <div style={{ float: "left" }} id={`${message.type}_msg`} key="error_alert">
                          <ul>
                            {temp.map( (x, index) => <li id={`error_${index}`} key={`error_${index}`}>{icon.failure}{x.replace("• ", "")}</li>)}
                          </ul>    
                        </div>    
                    

                          </UINotificationFailure>;
      break;

      default:
        notification =  <UINotificationWarning data-notif-warning>
                          <div style={{ float: "left" }} id={`${message.type}_msg`} key="warning_alert">
                            <ul>
                              {temp.map( (x, index) => <li id={`warning_${index}`} key={`warning_${index}`}>{icon.warning}{x.replace("• ", "")}</li>)}
                            </ul>  
                          </div>
                        </UINotificationWarning>;

    }

  }

  return <Wrapper show={!!message}>{notification}</Wrapper>;
};

MessageTray.propTypes = {
  message: PropTypes.shape({
    text: PropTypes.string,
    type: PropTypes.string
  })
};

export default MessageTray;
